$( document ).ready(function() {
  

	$('.product-comparison-list-slider').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows:false,
		dots:true,
		prevArrow: '<button class="custom-slick-navi slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_761_6790)"><rect width="48" height="48" rx="24" fill="white"/><path d="M24.0047 17.3013V21.5986H31.2042C32.5243 21.5986 33.6009 22.6752 33.6009 23.9953C33.6009 25.3154 32.5243 26.392 31.2042 26.392H24.0047V30.6893C24.0047 31.7659 22.7127 32.2996 21.9637 31.5319L15.2697 24.8379C14.7923 24.3604 14.7923 23.6115 15.2697 23.134L21.9637 16.44C22.7127 15.691 24.0047 16.2247 24.0047 17.3013ZM0 24.0047C0 37.2522 10.7478 48.0094 24.0047 48.0094C37.2616 48.0094 48.0094 37.2522 48.0094 24.0047C48.0094 10.7572 37.2522 0 24.0047 0C10.7572 0 0 10.7572 0 24.0047Z" fill="#FF595A"/></g><defs><clipPath id="clip0_761_6790"><rect width="48" height="48" rx="24" fill="white"/></clipPath></defs></svg></button>',
		nextArrow: '<button class="custom-slick-navi slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_761_6787)"><rect width="48" height="48" rx="24" transform="matrix(-1 0 0 1 48 0)" fill="white"/><path d="M23.9953 17.3013V21.5986H16.7958C15.4757 21.5986 14.3991 22.6752 14.3991 23.9953C14.3991 25.3154 15.4757 26.392 16.7958 26.392H23.9953V30.6893C23.9953 31.7659 25.2873 32.2996 26.0363 31.5319L32.7303 24.8379C33.2077 24.3604 33.2077 23.6115 32.7303 23.134L26.0363 16.44C25.2873 15.691 23.9953 16.2247 23.9953 17.3013ZM48 24.0047C48 37.2522 37.2522 48.0094 23.9953 48.0094C10.7384 48.0094 -0.00936127 37.2522 -0.00936127 24.0047C-0.00936127 10.7572 10.7478 0 23.9953 0C37.2428 0 48 10.7572 48 24.0047Z" fill="#FF595A"/></g><defs><clipPath id="clip0_761_6787"><rect width="48" height="48" rx="24" transform="matrix(-1 0 0 1 48 0)" fill="white"/></clipPath></defs></svg></button>',
		responsive: [ 
		  {
			breakpoint: 991,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1    
			}
		  },
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1    
			}
		  }     
		]
	  });   
	
	

	  });   
	